import { useInfiniteQuery } from '@tanstack/react-query';
import type { ArticleMineItemDto, Paginated } from '@zoxo/shared';

import { api } from '../../lib/api';

/**
 * The viewer's own PD 수첩 articles (GET /articles/mine, auth-only). Unlike the
 * public feed this INCLUDES pending (isActive=false) submissions, so the author
 * can find and edit a not-yet-approved article (V4 §C). useInfiniteQuery (not
 * Suspense) per the infinite-scroll exception; the cursor is opaque (whatever
 * `meta.nextCursor` returns is sent back as `?cursor=`).
 */
export function useMyArticles() {
  return useInfiniteQuery({
    queryKey: ['articles', 'mine'],
    queryFn: ({ pageParam }) => {
      const qs = pageParam ? `?cursor=${encodeURIComponent(pageParam)}` : '';
      return api.get<Paginated<ArticleMineItemDto>>(`/articles/mine${qs}`);
    },
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.meta.nextCursor ?? undefined,
  });
}
